import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BreadcrumbContext = createContext();

export function BreadcrumbProvider({ children }) {
  const [dynamicLabel, setDynamicLabelState] = useState(null);
  const location = useLocation();

  // Reset dynamic label on navigation
  useEffect(() => {
    setDynamicLabelState(null);
  }, [location.pathname]);

  const setDynamicLabel = useCallback((label) => {
    setDynamicLabelState(label);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ dynamicLabel, setDynamicLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider');
  }
  return context;
}
